import * as helpers from '@mindtickle/ui-shell-core/Berry';

function useBerryHelpers() {
  return helpers;
}

export default useBerryHelpers;
